module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_team_balancing-small-d257fe1749b495460e79c4d6ac6a10f8.png";